export enum APIPATH {
    bingSearch = "/api/v7//search?q={queryParams}&appid=8F57215FA513CFCF117BCA94D5E5AD458F470894&mkt=zh-CN", // 12.29
}
